import React from 'react'

export const arrowDownIcn = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.56044 7.18555C5.17136 7.44953 4.63748 7.40914 4.29271 7.06437L1.46428 4.23594C1.07376 3.84542 1.07376 3.21225 1.46428 2.82173C1.8548 2.4312 2.48797
       2.4312 2.87849 2.82173L4.99982 4.94305L7.12117 2.8217C7.51169 2.43118 8.14486 2.43118 8.53538 2.8217C8.9259 3.21223 8.9259 3.84539 8.53538 4.23592L5.70695
        7.06434C5.70207 7.06923 5.69714 7.07406 5.69218 7.07882C5.65067 7.11868 5.60658 7.15425 5.56044 7.18555Z"
      fill="currentColor"
      fillOpacity="0.85"
    />
  </svg>
)

export const logOutIcn = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path
      d="M2.91667 12.25C2.59583 12.25 2.32118 12.1358 2.09271 11.9073C1.86424 11.6788 1.75 11.4042 1.75 11.0833V2.91667C1.75 2.59583 1.86424 2.32118 2.09271
       2.09271C2.32118 1.86424 2.59583 1.75 2.91667 1.75H7V2.91667H2.91667V11.0833H7V12.25H2.91667ZM9.33333 9.91667L8.53125 9.07083L10.0188
        7.58333H5.25V6.41667H10.0188L8.53125 4.92917L9.33333 4.08333L12.25 7L9.33333 9.91667Z"
      fill="currentColor"
    />
  </svg>
)

export const addIcn = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.02107 2.66675C8.38926 2.66723 8.68734 2.9661 8.68686 3.33429L8.68162 7.33341H12.6666C13.0348 7.33341 13.3333 7.63189 13.3333 8.00008C13.3333 8.36827
       13.0348 8.66675 12.6666 8.66675H8.67987L8.67462 12.6676C8.67414 13.0358 8.37527 13.3339 8.00708 13.3334C7.6389 13.3329 7.34081 13.0341 7.34129 12.6659L7.34653
        8.66675H3.33329C2.9651 8.66675 2.66663 8.36827 2.66663 8.00008C2.66663 7.63189 2.9651 7.33341 3.33329 7.33341H7.34828L7.35353 3.33254C7.35401 2.96435 7.65288
         2.66627 8.02107 2.66675Z"
      fill="currentColor"
    />
  </svg>
)

export const pencilIcn = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
    <path
      d="M9.85625 13.1188L16.1375 6.8375L15.1625 5.8625L8.88125 12.1438L9.85625 13.1188ZM4.9625 14.75C3.7125 14.6875 2.78125 14.425 2.16875 13.9625C1.55625 13.5
       1.25 12.8313 1.25 11.9563C1.25 11.1438 1.58437 10.4844 2.25313 9.97813C2.92188 9.47188 3.85 9.16875 5.0375 9.06875C5.525 9.03125 5.89062 8.95312 6.13438
        8.83438C6.37813 8.71563 6.5 8.55 6.5 8.3375C6.5 8.0125 6.31563 7.76875 5.94688 7.60625C5.57812 7.44375 4.96875 7.325 4.11875 7.25L4.25 5.75C5.5375 5.85
         6.48438 6.10938 7.09063 6.52813C7.69688 6.94688 8 7.55 8 8.3375C8 9 7.75938 9.51875 7.27813 9.89375C6.79688 10.2688 6.0875 10.4938 5.15 10.5688C4.35
          10.6313 3.75 10.7781 3.35 11.0094C2.95 11.2406 2.75 11.5563 2.75 11.9563C2.75 12.3938 2.925 12.7094 3.275 12.9031C3.625 13.0969 4.2125 13.2125 5.0375
           13.25L4.9625 14.75ZM10.2125 14.8813L7.11875 11.7875L14.2813 4.625C14.5313 4.375 14.8281 4.25 15.1719 4.25C15.5156 4.25 15.8125 4.375 16.0625 4.625L17.375
            5.9375C17.625 6.1875 17.75 6.48438 17.75 6.82812C17.75 7.17188 17.625 7.46875 17.375 7.71875L10.2125 14.8813ZM7.23125 15.5C7.01875 15.55 6.83125 15.4938
             6.66875 15.3313C6.50625 15.1688 6.45 14.9813 6.5 14.7688L7.11875 11.7875L10.2125 14.8813L7.23125 15.5Z"
      fill="currentColor"
    />
  </svg>
)

export const moreVerticalIcn = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
    <path
      d="M7.875 3.85742C7.875 4.15579 7.99353 4.44194 8.2045 4.65292C8.41548 4.8639 8.70163 4.98242 9 4.98242C9.29837 4.98242 9.58452 4.8639 9.79549 4.65292C10.0065
       4.44194 10.125 4.15579 10.125 3.85742C10.125 3.55905 10.0065 3.27291 9.79549 3.06193C9.58452 2.85095 9.29837 2.73242 9 2.73242C8.70163 2.73242 8.41548 2.85095
        8.2045 3.06193C7.99353 3.27291 7.875 3.55905 7.875 3.85742ZM7.875 9.48242C7.875 9.78079 7.99353 10.0669 8.2045 10.2779C8.41548 10.4889 8.70163 10.6074
         9 10.6074C9.29837 10.6074 9.58452 10.4889 9.79549 10.2779C10.0065 10.0669 10.125 9.78079 10.125 9.48242C10.125 9.18405 10.0065 8.89791 9.79549 8.68693C9.58452
          8.47595 9.29837 8.35742 9 8.35742C8.70163 8.35742 8.41548 8.47595 8.2045 8.68693C7.99353 8.89791 7.875 9.18405 7.875 9.48242ZM7.875 15.1074C7.875 15.4058
           7.99353 15.6919 8.2045 15.9029C8.41548 16.1139 8.70163 16.2324 9 16.2324C9.29837 16.2324 9.58452 16.1139 9.79549 15.9029C10.0065 15.6919 10.125 15.4058
            10.125 15.1074C10.125 14.8091 10.0065 14.5229 9.79549 14.3119C9.58452 14.1009 9.29837 13.9824 9 13.9824C8.70163 13.9824 8.41548 14.1009 8.2045 14.3119C7.99353
             14.5229 7.875 14.8091 7.875 15.1074Z"
      fill="currentColor"
    />
  </svg>
)

export const userIcn = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 12C10.9 12 9.95833 11.6083 9.175 10.825C8.39167 10.0417 8 9.1 8 8C8 6.9 8.39167 5.95833 9.175 5.175C9.95833 4.39167 10.9 4 12 4C13.1 4 14.0417 4.39167 14.825
       5.175C15.6083 5.95833 16 6.9 16 8C16 9.1 15.6083 10.0417 14.825 10.825C14.0417 11.6083 13.1 12 12 12ZM4 20V17.2C4 16.6333 4.14583 16.1125 4.4375 15.6375C4.72917 15.1625
        5.11667 14.8 5.6 14.55C6.63333 14.0333 7.68333 13.6458 8.75 13.3875C9.81667 13.1292 10.9 13 12 13C13.1 13 14.1833 13.1292 15.25 13.3875C16.3167 13.6458 17.3667 14.0333
         18.4 14.55C18.8833 14.8 19.2708 15.1625 19.5625 15.6375C19.8542 16.1125 20 16.6333 20 17.2V20H4ZM6 18H18V17.2C18 17.0167 17.9542 16.85 17.8625 16.7C17.7708 16.55 17.65
          16.4333 17.5 16.35C16.6 15.9 15.6917 15.5625 14.775 15.3375C13.8583 15.1125 12.9333 15 12 15C11.0667 15 10.1417 15.1125 9.225 15.3375C8.30833 15.5625 7.4 15.9 6.5
           16.35C6.35 16.4333 6.22917 16.55 6.1375 16.7C6.04583 16.85 6 17.0167 6 17.2V18ZM12 10C12.55 10 13.0208 9.80417 13.4125 9.4125C13.8042 9.02083 14 8.55 14 8C14 7.45
            13.8042 6.97917 13.4125 6.5875C13.0208 6.19583 12.55 6 12 6C11.45 6 10.9792 6.19583 10.5875 6.5875C10.1958 6.97917 10 7.45 10 8C10 8.55 10.1958 9.02083 10.5875
             9.4125C10.9792 9.80417 11.45 10 12 10Z"
      fill="currentColor"
    />
  </svg>
)

export const editIcn = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path
      d="M2.91667 11.0833H3.74792L9.45 5.38125L8.61875 4.55L2.91667 10.2521V11.0833ZM1.75 12.25V9.77083L9.45 2.08542C9.56667 1.97847 9.69549 1.89583 9.83646
       1.8375C9.97743 1.77917 10.1257 1.75 10.2813 1.75C10.4368 1.75 10.5875 1.77917 10.7333 1.8375C10.8792 1.89583 11.0056 1.98333 11.1125 2.1L11.9146 2.91667C12.0313
        3.02361 12.1163 3.15 12.1698 3.29583C12.2233 3.44167 12.25 3.5875 12.25 3.73333C12.25 3.88889 12.2233 4.03715 12.1698 4.17813C12.1163 4.3191 12.0313 4.44792
         11.9146 4.56458L4.22917 12.25H1.75ZM9.02708 4.97292L8.61875 4.55L9.45 5.38125L9.02708 4.97292Z"
      fill="currentColor"
    />
  </svg>
)

export const deleteIcn = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M10 9C10.5523 9 11 9.44771 11 10V16.5C11 17.0523 10.5523 17.5 10 17.5C9.44771 17.5 9 17.0523 9 16.5V10C9 9.44771 9.44771 9 10 9Z" fill="currentColor" />
    <path d="M15 10C15 9.44771 14.5523 9 14 9C13.4477 9 13 9.44771 13 10V16.5C13 17.0523 13.4477 17.5 14 17.5C14.5523 17.5 15 17.0523 15 16.5V10Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.6445 1C9.2793 1 8.94315 1.19908 8.76761 1.51932L7.40778 4H2C1.44772 4 1 4.44772 1 5C1 5.55228 1.44772 6 2 6H3.5V22C3.5 22.5523 3.94772 23 4.5 23H19.5C20.0523
       23 20.5 22.5523 20.5 22V6H22C22.5523 6 23 5.55228 23 5C23 4.44772 22.5523 4 22 4H16.598L15.2695 1.5268C15.0952 1.20239 14.7568 1 14.3885 1H9.6445ZM14.3277 4L13.7906
        3H10.2367L9.68856 4H14.3277ZM5.5 6V21H18.5V6H5.5Z"
      fill="currentColor"
    />
  </svg>
)

export const stethoscopeIcn = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M13.5 22C11.7 22 10.1667 21.3667 8.9 20.1C7.63333 18.8333 7 17.3 7 15.5V14.925C5.56667 14.6917 4.375 14.0208 3.425 12.9125C2.475 11.8042 2 10.5 2
     9V3H5V2H7V6H5V5H4V9C4 10.1 4.39167 11.0417 5.175 11.825C5.95833 12.6083 6.9 13 8 13C9.1 13 10.0417 12.6083 10.825 11.825C11.6083 11.0417 12 10.1 12
     9V5H11V6H9V2H11V3H14V9C14 10.5 13.525 11.8042 12.575 12.9125C11.625 14.0208 10.4333 14.6917 9 14.925V15.5C9 16.75 9.4375 17.8125 10.3125 18.6875C11.1875
     19.5625 12.25 20 13.5 20C14.75 20 15.8125
       19.5625 16.6875 18.6875C17.5625 17.8125 18 16.75 18 15.5V13.825C17.4167 13.625 16.9375 13.2667 16.5625 12.75C16.1875 12.2333 16 11.65 16 11C16 10.1667 16.2917 9.45833
        16.875 8.875C17.4583 8.29167 18.1667 8 19 8C19.8333 8 20.5417 8.29167 21.125 8.875C21.7083 9.45833 22 10.1667 22 11C22 11.65 21.8125 12.2333 21.4375 12.75C21.0625 13.2667
         20.5833 13.625 20 13.825V15.5C20 17.3 19.3667 18.8333 18.1 20.1C16.8333 21.3667 15.3 22 13.5 22ZM19 12C19.2833 12 19.5208 11.9042 19.7125 11.7125C19.9042 11.5208 20
         11.2833 20 11C20 10.7167 19.9042 10.4792 19.7125 10.2875C19.5208 10.0958 19.2833 10 19 10C18.7167 10 18.4792 10.0958 18.2875 10.2875C18.0958 10.4792 18 10.7167 18 11C18
         11.2833 18.0958 11.5208 18.2875 11.7125C18.4792 11.9042 18.7167 12 19 12Z"
      fill="currentColor"
    />
  </svg>
)

export const manageUserIcn = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M10 12C8.9 12 7.95833 11.6083 7.175 10.825C6.39167 10.0417 6 9.1 6 8C6 6.9 6.39167 5.95833 7.175 5.175C7.95833 4.39167 8.9 4 10 4C11.1 4 12.0417 4.39167 12.825
       5.175C13.6083 5.95833 14 6.9 14 8C14 9.1 13.6083 10.0417 12.825 10.825C12.0417 11.6083 11.1 12 10 12ZM2 20V17.2C2 16.65 2.14167 16.1333 2.425 15.65C2.70833 15.1667
        3.1 14.8 3.6 14.55C4.45 14.1167 5.40833 13.75 6.475 13.45C7.54167 13.15 8.71667 13 10 13H10.35C10.45 13 10.55 13.0167 10.65 13.05C10.5167 13.35 10.4042 13.6625
         10.3125 13.9875C10.2208 14.3125 10.15 14.65 10.1 15H10C8.81667 15 7.75417 15.15 6.8125 15.45C5.87083 15.75 5.1 16.05 4.5 16.35C4.35 16.4333 4.22917 16.55 4.1375
          16.7C4.04583 16.85 4 17.0167 4 17.2V18H10.3C10.4 18.35 10.5333 18.6958 10.7 19.0375C10.8667 19.3792 11.05 19.7 11.25 20H2ZM16 21L15.7 19.5C15.5 19.4167 15.3125
           19.3292 15.1375 19.2375C14.9625 19.1458 14.7833 19.0333 14.6 18.9L13.15 19.35L12.15 17.65L13.3 16.65C13.2667 16.4167 13.25 16.2 13.25 16C13.25 15.8 13.2667
            15.5833 13.3 15.35L12.15 14.35L13.15 12.65L14.6 13.1C14.7833 12.9667 14.9625 12.8542 15.1375 12.7625C15.3125 12.6708 15.5 12.5833 15.7 12.5L16 11H18L18.3
             12.5C18.5 12.5833 18.6875 12.675 18.8625 12.775C19.0375 12.875 19.2167 13 19.4 13.15L20.85 12.65L21.85 14.4L20.7 15.4C20.7333 15.6 20.75 15.8083 20.75
              16.025C20.75 16.2417 20.7333 16.45 20.7 16.65L21.85 17.65L20.85 19.35L19.4 18.9C19.2167 19.0333 19.0375 19.1458 18.8625 19.2375C18.6875 19.3292 18.5 19.4167
               18.3 19.5L18 21H16ZM17 18C17.55 18 18.0208 17.8042 18.4125 17.4125C18.8042 17.0208 19 16.55 19 16C19 15.45 18.8042 14.9792 18.4125 14.5875C18.0208 14.1958
                17.55 14 17 14C16.45 14 15.9792 14.1958 15.5875 14.5875C15.1958 14.9792 15 15.45 15 16C15 16.55 15.1958 17.0208 15.5875 17.4125C15.9792 17.8042 16.45 18
                 17 18ZM10 10C10.55 10 11.0208 9.80417 11.4125 9.4125C11.8042 9.02083 12 8.55 12 8C12 7.45 11.8042 6.97917 11.4125 6.5875C11.0208 6.19583 10.55 6 10 6C9.45
                  6 8.97917 6.19583 8.5875 6.5875C8.19583 6.97917 8 7.45 8 8C8 8.55 8.19583 9.02083 8.5875 9.4125C8.97917 9.80417 9.45 10 10 10Z"
      fill="currentColor"
    />
  </svg>
)

export const phoneIcn = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M19.95 21C17.8667 21 15.8083 20.5458 13.775 19.6375C11.7417 18.7292 9.89167 17.4417 8.225 15.775C6.55833 14.1083 5.27083 12.2583 4.3625 10.225C3.45417 8.19167
       3 6.13333 3 4.05C3 3.75 3.1 3.5 3.3 3.3C3.5 3.1 3.75 3 4.05 3H8.1C8.33333 3 8.54167 3.07917 8.725 3.2375C8.90833 3.39583 9.01667 3.58333 9.05 3.8L9.7 7.3C9.73333
        7.56667 9.725 7.79167 9.675 7.975C9.625 8.15833 9.53333 8.31667 9.4 8.45L6.975 10.9C7.30833 11.5167 7.70417 12.1125 8.1625 12.6875C8.62083 13.2625 9.125 13.8167
         9.675 14.35C10.1917 14.8667 10.7333 15.3458 11.3 15.7875C11.8667 16.2292 12.4667 16.6333 13.1 17L15.45 14.65C15.6 14.5 15.7958 14.3875 16.0375 14.3125C16.2792
          14.2375 16.5167 14.2167 16.75 14.25L20.2 14.95C20.4333 15.0167 20.625 15.1375 20.775 15.3125C20.925 15.4875 21 15.6833 21 15.9V19.95C21 20.25 20.9 20.5 20.7
           20.7C20.5 20.9 20.25 21 19.95 21ZM6.025 9L7.675 7.35L7.25 5H5.025C5.10833 5.68333 5.225 6.35833 5.375 7.025C5.525 7.69167 5.74167 8.35 6.025 9ZM14.975 17.95C15.625
            18.2333 16.2875 18.4583 16.9625 18.625C17.6375 18.7917 18.3167 18.9 19 18.95V16.75L16.65 16.275L14.975 17.95Z"
      fill="#303443"
    />
  </svg>
)

export const emailIcn = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208
       4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4ZM12 13L4 8V18H20V8L12 13ZM12 11L20
        6H4L12 11ZM4 8V6V18V8Z"
      fill="#303443"
    />
  </svg>
)

export const locationIcn = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 12C12.55 12 13.0208 11.8042 13.4125 11.4125C13.8042 11.0208 14 10.55 14 10C14 9.45 13.8042 8.97917 13.4125 8.5875C13.0208 8.19583 12.55 8 12 8C11.45 8 10.9792
       8.19583 10.5875 8.5875C10.1958 8.97917 10 9.45 10 10C10 10.55 10.1958 11.0208 10.5875 11.4125C10.9792 11.8042 11.45 12 12 12ZM12 19.35C14.0333 17.4833 15.5417
        15.7875 16.525 14.2625C17.5083 12.7375 18 11.3833 18 10.2C18 8.38333 17.4208 6.89583 16.2625 5.7375C15.1042 4.57917 13.6833 4 12 4C10.3167 4 8.89583 4.57917
         7.7375 5.7375C6.57917 6.89583 6 8.38333 6 10.2C6 11.3833 6.49167 12.7375 7.475 14.2625C8.45833 15.7875 9.96667 17.4833 12 19.35ZM12 22C9.31667 19.7167 7.3125
          17.5958 5.9875 15.6375C4.6625 13.6792 4 11.8667 4 10.2C4 7.7 4.80417 5.70833 6.4125 4.225C8.02083 2.74167 9.88333 2 12 2C14.1167 2 15.9792 2.74167 17.5875
           4.225C19.1958 5.70833 20 7.7 20 10.2C20 11.8667 19.3375 13.6792 18.0125 15.6375C16.6875 17.5958 14.6833 19.7167 12 22Z"
      fill="#303443"
    />
  </svg>
)

export const sendIcn = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 20V4L22 12L3 20ZM5 17L16.85 12L5 7V10.5L11 12L5 13.5V17Z" fill="#303443" />
  </svg>
)

export const userAvatarPlaceholderIcn = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 17H16V16.45C16 15.7 15.6333 15.1042 14.9 14.6625C14.1667 14.2208 13.2 14 12 14C10.8 14 9.83333 14.2208 9.1 14.6625C8.36667 15.1042 8 15.7 8 16.45V17ZM12 13C12.55
       13 13.0208 12.8042 13.4125 12.4125C13.8042 12.0208 14 11.55 14 11C14 10.45 13.8042 9.97917 13.4125 9.5875C13.0208 9.19583 12.55 9 12 9C11.45 9 10.9792 9.19583 10.5875
        9.5875C10.1958 9.97917 10 10.45 10 11C10 11.55 10.1958 12.0208 10.5875 12.4125C10.9792 12.8042 11.45 13 12 13ZM4 21C3.45 21 2.97917 20.8042 2.5875 20.4125C2.19583
         20.0208 2 19.55 2 19V7C2 6.45 2.19583 5.97917 2.5875 5.5875C2.97917 5.19583 3.45 5 4 5H7.15L9 3H15L16.85 5H20C20.55 5 21.0208 5.19583 21.4125 5.5875C21.8042 5.97917
          22 6.45 22 7V19C22 19.55 21.8042 20.0208 21.4125 20.4125C21.0208 20.8042 20.55 21 20 21H4ZM4 19H20V7H15.95L14.125 5H9.875L8.05 7H4V19Z"
      fill="#303443"
    />
  </svg>
)

export const keypairIcn = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1150_1319)">
      <mask id="mask0_1150_1319" maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14">
        <path d="M14 0H0V14H14V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_1150_1319)">
        <path
          d="M4.2175 6.44583H7.00001L7.58334 4.77167H12.6L13.1542 3.6575L12.6 2.54333H7.58334L7.00001 0.875H4.2175C3.77449 0.875 3.34954 1.05058 3.03574 1.36328C2.72194 1.67599
           2.54487 2.10033 2.54333 2.54333V4.77167C2.54487 5.21521 2.72175 5.64015 3.03538 5.95379C3.34902 6.26739 3.77395 6.44432 4.2175 6.44583Z"
          stroke="#303443"
          strokeMiterlimit="10"
        />
        <path d="M4.77173 4.7713V2.54297" stroke="#303443" strokeMiterlimit="10" />
        <path d="M10.8967 3.65713V2.54297" stroke="#303443" strokeMiterlimit="10" />
        <path d="M9.22827 3.65713V2.54297" stroke="#303443" strokeMiterlimit="10" />
        <path
          d="M7.58337 4.77148L9.21087 6.41649L8.42337 7.99149L9.59004 9.15816L10.7567 10.3248L11.9234 11.4915L11.5384 12.6582L10.3717 13.0548L6.82504 9.51399L5.25007
           10.3715L3.30757 8.39982C3.00755 8.1004 2.83276 7.69801 2.81867 7.2744C2.80459 6.85078 2.95227 6.43767 3.23173 6.11899"
          stroke="#303443"
          strokeMiterlimit="10"
        />
        <path d="M6.05507 6.44629L4.88257 7.61296" stroke="#303443" strokeMiterlimit="10" />
        <path d="M9.99841 11.1588L10.7859 10.3713" stroke="#303443" strokeMiterlimit="10" />
        <path d="M8.82007 9.975L9.60757 9.1875" stroke="#303443" strokeMiterlimit="10" />
        <path
          d="M2.85252 7.54256C2.33633 7.48294 1.85719 7.24483 1.49799 6.86933C1.1388 6.49378 0.922122 6.0046 0.885442 5.48625C0.848768 4.96791 0.994391 4.45306 1.29714
           4.03072C1.59987 3.60839 2.0407 3.30514 2.54336 3.17342C2.94212 3.07111 3.36143 3.08128 3.75477 3.20278C4.14811 3.32428 4.5001 3.55237 4.7717 3.86175"
          stroke="#303443"
          strokeMiterlimit="10"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1150_1319">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const shareIcn = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1270_1320)">
      <path
        d="M18 16.08C17.24 16.08 16.56 16.38 16.04 16.85L8.91 12.7C8.96 12.47 9 12.24 9 12C9 11.76 8.96 11.53 8.91 11.3L15.96 7.19C16.5 7.69 17.21 8 18 8C19.66 8 21 6.66 21
        5C21 3.34 19.66 2 18 2C16.34 2 15 3.34 15 5C15 5.24 15.04 5.47 15.09 5.7L8.04 9.81C7.5 9.31 6.79 9 6 9C4.34 9 3 10.34 3 12C3 13.66 4.34 15 6 15C6.79 15 7.5 14.69 8.04
        14.19L15.16 18.35C15.11 18.56 15.08 18.78 15.08 19C15.08 20.61 16.39 21.92 18 21.92C19.61 21.92 20.92 20.61 20.92 19C20.92 17.39 19.61 16.08 18 16.08Z"
        fill="#303443"
      />
    </g>
    <defs>
      <clipPath id="clip0_1270_1320">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const uploadIcn = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_1345_962" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
      <rect width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1345_962)">
      <path
        d="M7.33317 10.6667V5.23341L5.59984 6.96675L4.6665 6.00008L7.99984 2.66675L11.3332 6.00008L10.3998 6.96675L8.6665 5.23341V10.6667H7.33317ZM3.99984 13.3334C3.63317
         13.3334 3.31928 13.2029 3.05817 12.9417C2.79706 12.6806 2.6665 12.3667 2.6665 12.0001V10.0001H3.99984V12.0001H11.9998V10.0001H13.3332V12.0001C13.3332 12.3667
          13.2026 12.6806 12.9415 12.9417C12.6804 13.2029 12.3665 13.3334 11.9998 13.3334H3.99984Z"
        fill="#FCFCFD"
      />
    </g>
  </svg>
)

export const attachedFileIcn = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_1373_2258" maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14">
      <rect width="14" height="14" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1373_2258)">
      <path
        d="M10.4997 9.18758C10.4997 10.1987 10.1448 11.0591 9.43509 11.7688C8.72537 12.4786 7.86495 12.8334 6.85384 12.8334C5.84273 12.8334 4.98231 12.4786 4.27259
         11.7688C3.56287 11.0591 3.20801 10.1987 3.20801 9.18758V3.79175C3.20801 3.06258 3.46322 2.44279 3.97363 1.93237C4.48405 1.42196 5.10384 1.16675 5.83301 1.16675C6.56217
          1.16675 7.18197 1.42196 7.69238 1.93237C8.2028 2.44279 8.45801 3.06258 8.45801 3.79175V8.89591C8.45801 9.34314 8.30245 9.7223 7.99134 10.0334C7.68023 10.3445 7.30106
           10.5001 6.85384 10.5001C6.40662 10.5001 6.02745 10.3445 5.71634 10.0334C5.40523 9.7223 5.24967 9.34314 5.24967 8.89591V3.50008H6.41634V8.89591C6.41634 9.0223 6.45766
            9.12682 6.5403 9.20946C6.62294 9.2921 6.72745 9.33341 6.85384 9.33341C6.98023 9.33341 7.08474 9.2921 7.16738 9.20946C7.25002 9.12682 7.29134 9.0223 7.29134
             8.89591V3.79175C7.28162 3.38341 7.13822 3.03828 6.86113 2.75633C6.58405 2.47439 6.24134 2.33341 5.83301 2.33341C5.42467 2.33341 5.07954 2.47439 4.79759
              2.75633C4.51565 3.03828 4.37467 3.38341 4.37467 3.79175V9.18758C4.36495 9.87786 4.60315 10.4636 5.08926 10.9449C5.57537 11.4261 6.16356 11.6667 6.85384
               11.6667C7.5344 11.6667 8.11287 11.4261 8.58926 10.9449C9.06565 10.4636 9.31356 9.87786 9.33301 9.18758V3.50008H10.4997V9.18758Z"
        fill="#3D87C5"
      />
    </g>
  </svg>
)

export const prescriptionIcn = () => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_2034_1550" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
      <rect x="0.0926514" y="0.385742" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2034_1550)">
      <path
        d="M17.0427 21.0357L18.1927 19.8857L16.5927 18.2857L15.4427 19.4357C15.2093 19.6691 15.0927 19.9357 15.0927 20.2357C15.0927 20.5357 15.2093 20.8024 15.4427 21.0357C15.676
        21.2691 15.9427 21.3857 16.2427 21.3857C16.5427 21.3857 16.8093 21.2691 17.0427 21.0357ZM19.5927 18.4857L20.7427 17.3357C20.976 17.1024 21.0927 16.8357 21.0927
         16.5357C21.0927 16.2357 20.976 15.9691 20.7427 15.7357C20.5093 15.5024 20.2427 15.3857 19.9427 15.3857C19.6427 15.3857 19.376 15.5024 19.1427 15.7357L17.9927
          16.8857L19.5927 18.4857ZM18.4677 22.4607C17.851 23.0774 17.1093 23.3857 16.2427 23.3857C15.376 23.3857 14.6343 23.0774 14.0177 22.4607C13.401 21.8441 13.0927 21.1024
           13.0927 20.2357C13.0927 19.3691 13.401 18.6274 14.0177 18.0107L17.7177 14.3107C18.3343 13.6941 19.076 13.3857 19.9427 13.3857C20.8093 13.3857 21.551 13.6941 22.1677
            14.3107C22.7843 14.9274 23.0927 15.6691 23.0927 16.5357C23.0927 17.4024 22.7843 18.1441 22.1677 18.7607L18.4677 22.4607ZM5.09265 21.3857C4.54265 21.3857 4.07182
            21.1899 3.68015 20.7982C3.28848 20.4066 3.09265 19.9357 3.09265 19.3857V5.38574C3.09265 4.83574 3.28848 4.36491 3.68015 3.97324C4.07182 3.58158 4.54265 3.38574 5.09265
             3.38574H9.29265C9.50932 2.78574 9.87182 2.30241 10.3802 1.93574C10.8885 1.56908 11.4593 1.38574 12.0927 1.38574C12.726 1.38574 13.2968 1.56908 13.8052 1.93574C14.3135
              2.30241 14.676 2.78574 14.8927 3.38574H19.0927C19.6427 3.38574 20.1135 3.58158 20.5052 3.97324C20.8968 4.36491 21.0927 4.83574 21.0927 5.38574V11.5107C20.7593
               11.4274 20.426 11.3857 20.0927 11.3857C19.7593 11.3857 19.426 11.4107 19.0927 11.4607V5.38574H5.09265V19.3857H11.1677C11.1177 19.7191 11.0927 20.0524 11.0927
               20.3857C11.0927 20.7191 11.1343 21.0524 11.2177 21.3857H5.09265ZM12.0927 4.63574C12.3093 4.63574 12.4885 4.56491 12.6302 4.42324C12.7718 4.28158 12.8427 4.10241
               12.8427 3.88574C12.8427 3.66908 12.7718 3.48991 12.6302 3.34824C12.4885 3.20658 12.3093 3.13574 12.0927 3.13574C11.876 3.13574 11.6968 3.20658 11.5552
               3.34824C11.4135 3.48991 11.3427 3.66908 11.3427 3.88574C11.3427 4.10241 11.4135 4.28158 11.5552 4.42324C11.6968 4.56491 11.876 4.63574 12.0927 4.63574ZM7.09265
                9.38574V7.38574H17.0927V9.38574H7.09265ZM7.09265 13.3857V11.3857H17.0927V12.2357C16.9593 12.3191 16.8302 12.4149 16.7052 12.5232C16.5802 12.6316 16.451 12.7524
                16.3177 12.8857L15.8177 13.3857H7.09265ZM7.09265 17.3857V15.3857H13.8177L12.5927 16.6107C12.4593 16.7441 12.3385 16.8732 12.2302 16.9982C12.1218 17.1232 12.026
                17.2524 11.9427 17.3857H7.09265Z"
        fill="#1C1B1F"
      />
    </g>
  </svg>
)
